import { useState } from 'react';

import { useRouter } from 'next/router';

import arrowForward from 'public/assets/arrowForward.svg';
import document from 'public/assets/document.svg';

import { Spinner } from '../Spinner/Spinner';

interface CardProps {
  previewUrl: string | undefined;
  name: string;
  ipfsHash: string;
  timestamp: number;
}

const Card = ({ ipfsHash, previewUrl, name, timestamp }: CardProps) => {
  const currentTime = Math.floor(Date.now() / 1000);
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    await router.push(`ipfs/${ipfsHash}`);
    setIsLoading(false);
  };

  const calculateTime = () => {
    const endTime = currentTime;
    const startTime = timestamp;
    const differenceInMiliseconds = endTime - startTime;
    const differenceInSeconds = differenceInMiliseconds / 1000;
    const differenceInMinutes = differenceInSeconds / 60;
    const differenceInHours = differenceInMinutes / 60;
    const differenceInDays = differenceInHours / 24;
    if (differenceInMiliseconds < 0) {
      return `just now`;
    }
    if (differenceInHours > 24) {
      return `${Math.round(differenceInDays)} days ago`;
    }
    if (differenceInMinutes > 60) {
      return `${Math.round(differenceInHours)} hours ago`;
    }
    if (differenceInSeconds > 60) {
      return `${Math.round(differenceInMinutes)} mins ago`;
    }
    return `${Math.round(differenceInSeconds)} secs ago`;
  };
  const time = calculateTime();
  return (
    <div
      className="card bg-white rounded-md w-[225px] h-[315px] border"
      onClick={handleClick}
    >
      <div className="w-[225px] h-[250px] flex justify-center items-center">
        {isLoading ? (
          <Spinner />
        ) : (
          <img
            src={previewUrl || document.src}
            alt=""
            className={`rounded-t-md ${
              previewUrl ? 'w-[225px] h-[250px]' : 'w-[100px] h-[100px]'
            } bg-white`}
          />
        )}
      </div>
      <div className="card-info flex justify-between mt-1 p-2 ml-2">
        <div>
          <p className="name font-bold">
            {name.length > 15 ? `${name.substring(0, 15)}...` : name}
          </p>
          <p className="time text-sm">{time}</p>
        </div>
        <img src={arrowForward.src} alt="" className="w-5 mr-4" />
      </div>
    </div>
  );
};

export default Card;
